// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeadCell_root__3SJX8","headCellChildrenWrap":"TableHeadCell_headCellChildrenWrap__2HmpE"};